
import ItemCard from '@fixit/v-b2c-item/src/B2CItemCard.vue';
import RecSvc from './services/rec-svc';
import { Channel, ItemType, Location, ActionType } from './enums';

let service = null;

export default {
  name: 'RecommendationBox',
  data() {
    return {
      ActionType,
      recItems: [],
      isLoading: false,
      ItemType,
    };
  },
  components: {
    ItemCard,
  },
  props: {
    userId: {
      type: Number, // OnlineSsluttKundeId
    },
    chainId: {
      type: Number, // ChainId of the salon/homepage the customer is in
    },
    siteIds: {
      type: Array, // SiteId of the salon the customer is in : can be empty
    },
    itemType: {
      type: String, // Type of items wanted: products, tretments
      validator(value) {
        return Object.values(ItemType).includes(value);
      },
    },
    channel: {
      type: String, // Type of platforms App, FixitNo, HomePage, Salondata, Nettbutik
      validator(value) {
        return Object.values(Channel).includes(value);
      },
    },
    location: {
      type: String, // Type od location HomePage, ProductPage, Cart, TreatmentPage, WebshopFrontPage
      validator(value) {
        return Object.values(Location).includes(value);
      },
    },
    treatmentIds: {
      type: Array, // Object of TratmentIds array or ProducIds array
    },
    productIds: {
      type: Array, // Object of TratmentIds array or ProducIds array
    },
    presentation: {
      type: String, // grid or carousel
    },
    itemQty: {
      type: Number, // Number of items wantend : min 4,  max 12
    },
    urlBase: {
      type: String,
    },
    cartItemsIds: {
      type: Array,
    },
    boxTitle: {
      type: String,
    },
    btnText: {
      type: String,
    },
    employeeId: {
      type: String,
    },
    overrideText: {
      type: String,
      default: null,
    },
  },
  computed: {
    items() {
      return this.recItems;
    },
  },
  watch: {
    userId: {
      handler() {
        this.getRecommendation();
      },
      deep: true,
    },
    productIds: {
      handler(oldValue, newValue) {
        this.handleIdChange(oldValue, newValue);
      },
      deep: true,
    },
    treatmentIds: {
      handler(oldValue, newValue) {
        this.handleIdChange(oldValue, newValue);
      },
      deep: true,
    },
    cartItemsIds: {
      handler(_oldValue, newValue) {
        if (newValue) {
          this.recItems.forEach((item) => {
            const splittedUrl = item.urlSafe?.split('/') || '';
            if (newValue && newValue.includes(splittedUrl[1])) {
              item.isAdded = true;
            } else {
              item.isAdded = false;
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    stockAmount(id) {
      var stockAmount = 0;
      var item = this.recItems.filter((x) => x.id == id)[0];
      item.stockAmount.forEach((element) => {
        stockAmount += element.productStockAmount;
      });
      return stockAmount;
    },
    redirect(item) {
      this.logUserActivity(item, ActionType.Clicked);
      this.$emit('cardClick', item);
    },
    addToCard(item) {
      this.logUserActivity(item, ActionType.AddedToCart);
      this.$emit('buttonClick', item);
    },
    overrideBookingButton() {
      return this.overrideText && this.siteIds.length === 1;
    },
    priceHidden() {
      return this.$refs.recBox.classList.contains('price-hidden');
    },
    hideAddButton() {
      return this.$refs.recBox.classList.contains('add-hidden');
    },
    clickMoreBtn() {
      this.$emit('clickMoreBtn');
    },
    border() {
      return this.$refs.recBox.classList.contains('border');
    },
    handleIdChange(oldValue, newValue) {
      if (oldValue.length !== newValue.length) {
        this.getRecommendation();
      } else {
        for (let i = 0; i < newValue.length; i++) {
          if (oldValue[i] !== newValue[i]) {
            this.getRecommendation();
            break; // No need to continue the loop after finding a difference
          }
        }
      }
    },
    getRankingSourceById(id) {
      const item = this.recItems.find((item) => item.id === id);
      return item ? item.rankingSource : null;
    },
    getBase64ById(id) {
      const item = this.recItems.find((item) => item.id === id);
      return item ? item.idBase64 : null;
    },
    async getRecommendation() {
      this.isLoading = true;
      this.recItems = await service.getRecommendationItems({
        urlBase: this.urlBase,
        userId: this.userId,
        siteIds: this.siteIds,
        chainId: this.chainId,
        itemType: this.itemType,
        location: this.location,
        channel: this.channel,
        treatmentIds: this.treatmentIds,
        productIds: this.productIds,
        quantity: this.itemQty,
        cartItemsIds: this.cartItemsIds,
        employeeId: this.employeeId,
      });
      const hasItems = this.recItems.length > 0;
      this.$emit('itemsFetched', hasItems);
      this.isLoading = false;
    },
    async logUserActivity(item, action) {

      var id = this.getBase64ById(item.id);
      if (id != null && id != "") {
        this.logResp = await service.logUserActivity({
          urlBase: this.urlBase,
          userId: this.userId,
          isLoggedIn: this.userId ? true : false, // change
          chainId: this.chainId,
          siteIds: this.siteIds,
          location: this.location,
          channel: this.channel,
          location: this.location,
          // recommendationId: this.recommendationId
          rankingSource: this.getRankingSourceById(item.id),
          actionType: action,
          itemId: id,
          itemType: item.type,
        });
      }
    },
  },
  async mounted() {
    service = await RecSvc();
    this.getRecommendation();
  },
};
